module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/picture_3-0b3786a20966f4b301b16d70aafe1323.png";